import { Injectable } from '@angular/core';
import { Urls } from '@core/config/urls';
import { BaseApiService } from '@smartera/core';

@Injectable({
	providedIn: 'root',
})
export class ElasticsearchDataCollectorQueryMetaDataService extends BaseApiService<any> {
	override get apiUrl() {
		return `${Urls.BASE_URL.toString()}/elasticsearch-data-collector/query-meta-data`;
	}

	preview(obj: any) {
		return this._restClientService.post(`${this.apiUrl}/preview`, obj);
	}
}
